import type { RequestConfig } from '@customTypes/index';
import type { PenaltyItemDto } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type PostClubProfilePenaltiesRequest = {
  clubId: string;
  data: Omit<PenaltyItemDto, 'penaltyItemId'>[];
};

export type PostClubProfilePenaltiesParams =
  RequestConfig<PostClubProfilePenaltiesRequest>;

export const postClubProfilePenalties = async ({
  params,
  config
}: PostClubProfilePenaltiesParams) =>
  api.post(`/api/ClubProfile/penalties/${params.clubId}`, params.data, config);
